import { DISCLOSURE_BUTTON_CLASS } from './Constants';
import { findAssociatedLink, getJQuery, getSmartMenusInstance } from './Utils';
import { hasFocusWithin } from '../../Shared/DomUtils';

let $: JQueryStatic;

// =============================================================================
// Public Setup
// =============================================================================

/**
 * Manage focus interactions for disclosure buttons.
 *
 * When a disclosure button's associated menu is open and focus leaves the
 * entire <li> (including the submenu), close the menu.
 *
 * Uses setTimeout(fn, 0) to defer the focus check. This is necessary because
 * the focusout event fires before the focusin event on the new target element.
 * The deferred check runs after both events have completed, allowing us to
 * accurately determine whether focus has truly left the menu.
 */
export const setupFocusManagement = (menuSelectors: readonly string[]): void => {
    $ = getJQuery();

    menuSelectors.forEach((selector) => {
        $(selector)
            .find(`.${DISCLOSURE_BUTTON_CLASS}`)
            .each(function () {
                const $button = $(this);
                const $li = $button.closest('li');

                $li.on('focusout.ssDisclosure', () => {
                    // Defer: focusout fires before document.activeElement updates,
                    // so we wait for the focus transition to complete before checking.
                    setTimeout(() => {
                        if (hasFocusWithin($li) || $li.is(':hover')) return;
                        if ($button.attr('aria-expanded') !== 'true') return;

                        const $link = findAssociatedLink($button);
                        if (!$link) return;

                        const $sub = $link.dataSM('sub') as JQuery | undefined;
                        if (!$sub?.is(':visible')) return;

                        const smartmenus = getSmartMenusInstance($button);
                        if (smartmenus) {
                            smartmenus.menuHide($sub);
                        }
                        $button.attr('aria-expanded', 'false');
                    }, 0);
                });
            });
    });
};
